var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgToggleMenu = function SvgToggleMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 17.086"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22.425 17.086H.575A.62.62 0 0 1 0 16.429v-1.315a.62.62 0 0 1 .575-.657h21.85a.62.62 0 0 1 .575.657v1.314a.62.62 0 0 1-.575.658m0-7.229H.575A.62.62 0 0 1 0 9.2V7.886a.62.62 0 0 1 .575-.657h21.85a.62.62 0 0 1 .575.657V9.2a.62.62 0 0 1-.575.657m0-7.229H.575A.62.62 0 0 1 0 1.971V.657A.62.62 0 0 1 .575 0h21.85A.62.62 0 0 1 23 .657v1.314a.62.62 0 0 1-.575.658Z",
    "data-name": "Path 47569"
  })));
};
export default SvgToggleMenu;